import { Variant, Product } from "../../types/types";
import { encodeSize } from "../string/encodeSize";
import { getMainVariant } from "./getMainVariant";

export function getVariant(
  product: Product,
  colour: string | undefined,
  size: string | undefined,
) {
  const colourVariant = getColourVariant(colour, product);
  /* Size Variant
     - If there's a colour variant make sure size differentiator comes from that particular colour
     - Otherwise just loop through all sizes
     - size should take precedent over colour e.g sizeVariant || colourVariant || mainVariant
    */
  const sizeVariant = getSizeVariant(colour, size, product);
  return sizeVariant || colourVariant || getMainVariant(product);
}

function getColourVariant(colour: string | undefined, product: Product) {
  return colour ? findVariantByColour(product.variants, colour) : undefined;
}

function findVariantByColour(variants: Variant[], colour: string | undefined) {
  return variants.find((variant) => getUrlColour(variant) === colour);
}

function getSizeVariant(
  colour: string | undefined,
  size: string | undefined,
  product: Product,
) {
  return size ? getVariantBySize(product.variants, size, colour) : undefined;
}

function getVariantBySize(variants: Variant[], size: string, colour = "") {
  let searchVariants = variants;
  if (colour) {
    searchVariants = variants.filter(
      (variant) => getUrlColour(variant) === colour,
    );
  }

  return searchVariants.find(
    (variant) => encodeSize(variant.differentiators?.size) === size,
  );
}

// TODO WA-649 we want to get rid of this and match on the whole variant canonical url instead
function getUrlColour(variant: Variant): string | null {
  const pathParts = variant.canonicalURL.split("/");
  if (pathParts.length === 4) {
    return pathParts[2];
  } else {
    return null;
  }
}
